import { handleActions } from 'redux-actions'
import Immutable from 'immutable'
import * as actions from '../actions/auth'

const initialState = Immutable.fromJS({
  data: {
  },
  loading: false,
  loaded: false
})

export default handleActions({
  [actions.loginRequested] (state) {
    return state.delete('error').set('loading', true)
  },
  [actions.loginSucceeded] (state, action) {
    return state.set('loading', false).set('loaded', true)
      .update('data', v => v.merge(Immutable.fromJS(action.payload)))
  },
  [actions.loginFailed] (state, action) {
    let error = action.payload && action.payload.response;
    error = (error && error.data) || { message: '未知错误，请稍后再试' };
    return state.set('loading', false).merge(Immutable.fromJS({ error }))
  },
  [actions.logoutSucceeded] (state) {
    return state.set('login', false).set('loading', false).set('loaded', false);
  }
}, initialState)



// WEBPACK FOOTER //
// ./reducers/auth.js